export default "__VITE_ASSET__s$v$aFmP__"